import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function galleryVertical() {
    const containers = document.querySelectorAll('.gallery-vertical__container');

    containers.forEach(container => {
        const wrapper = container.querySelector('.gallery-vertical__wrapper');
        if (!wrapper) return;

        const items = wrapper.querySelectorAll('.gallery-vertical__item');
        if (items.length === 0) return;

        // Function to setup animation
        const setupAnimation = () => {
            // Clear any existing ScrollTrigger/Tweens if we were to support resize properly
            // But for now let's just build it.

            const vh = window.innerHeight;

            // Create Timeline
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    start: "top top",
                    end: "+=" + (items.length * 100) + "%", // Adjust scroll length based on number of items
                    pin: true,
                    scrub: 1, // Smooth scrubbing
                    invalidateOnRefresh: true
                }
            });

            items.forEach((item, i) => {
                const isFirst = i === 0;
                const isLast = i === items.length - 1;

                // We use function-based values for responsiveness
                const getHeight = () => item.offsetHeight || item.querySelector('img')?.offsetHeight || 300;

                // Initial Position
                // We set it immediately to avoid FOUC, but also use function in fromTo if needed.
                // However, for scrub, we usually define fromTo.

                // Start Y:
                // First item: Peeking (-30% of height)
                // Others: Hidden above (-120% of height or just offscreen)

                const getStartY = () => {
                    const h = getHeight();
                    if (isFirst) return -h * 0.3;
                    return -vh - h; // Start further up to delay appearance? Or just -h?
                    // If we start at -h, and we stagger the start time, it works.
                };

                // Actually, let's set initial state with gsap.set for all
                // But inside the timeline we use .to() from the current position?
                // Better to use .fromTo() to be explicit and handle resets.

                // Wait, if we use .fromTo(), we override the CSS/set values.

                // Let's use a simpler approach for startY of non-first items.
                // They should start just above the viewport.

                const startY = isFirst ? () => (window.innerHeight - getHeight()) / 2 : () => -getHeight() - 50;

                // End Y:
                // Last item: Center
                // Others: Bottom (vh + 50)
                const endY = isLast
                    ? () => (window.innerHeight - getHeight()) / 2
                    : () => window.innerHeight + 50;

                tl.fromTo(item,
                    {
                        y: startY,
                        zIndex: i + 1,
                        xPercent: -50, // Keep centered
                        left: "50%"
                    },
                    {
                        y: endY,
                        ease: "none",
                        duration: 1
                    },
                    i * 0.25 // Stagger start
                );
            });

            items.forEach((item) => {
                const image = item.querySelector('.gallery-vertical__full');

                if (!image) return;

                item.addEventListener('mouseenter', () => {
                    gsap.set(item, { zIndex: 1000 }); // Bring to front on hover
                    gsap.to(image, {
                        scale: 2.5,
                        duration: 0.5,
                        ease: "power2.out",
                        transformOrigin: "center center"
                    });
                });

                item.addEventListener('mouseleave', () => {                    
                    gsap.to(image, {
                        scale: 1,
                        duration: 0.7,
                        ease: "power2.in",
                        transformOrigin: "center center",
                        onComplete: () => {
                            gsap.set(item, { zIndex: 1 }); // Reset z-index on mouse leave
                        }
                    });
                });
            });
        };

        // Run setup
        // Wait for images to load to get heights?
        // Or just run it.
        setupAnimation();

        // Optional: Refresh on resize
        // ScrollTrigger handles invalidateOnRefresh, but we used function-based values so it should work.
    });
}
